var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tree-menu',{attrs:{"node":{ text: 'CIRCUIT LIBRARY', children: _vm.sourceTree },"depth":0},on:{"selected":function (x) { return _vm.$emit('onCodeTreeSelection', x.text); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }